import jexl from "jexl";
import "./css/customization.scss";

import Selection from "sulu-admin-bundle/containers/Form/fields/Selection";
import SingleSelect from "sulu-admin-bundle/containers/Form/fields/SingleSelect";

import { build } from "./values";
import { renderWithDisabled } from "./disabledOption";
import mountPrivacyConsentOverlay from "./js/privacy/PrivacyConsentOverlay";
import registerFields from "./js/fields/fields.js";
import registerViews from "./js/views/views.js";
import registeredListFields from "./js/listFields/index.js";
import registerTransformers from "./js/transformers/transformers.js";
import registerAdapters from "./js/adapter/adapters.js";
import registerListActions from "./js/listAction/listActions.js";
import MediaIframe from "./js/MediaIframe.js";

const initializeApp = () => {
    registerFields();
    registeredListFields();
    registerTransformers();
    registerViews();
    registerAdapters();
    registerListActions();
};

initializeApp();

jexl.addTransform("char_slash", (val) => val.split("/").length - 1);

Selection.prototype.buildRequestOptions = build;
SingleSelect.prototype.render = renderWithDisabled;

new MediaIframe();
mountPrivacyConsentOverlay();
